import { useState, useRef } from "react";
import { QrReader } from "react-qr-reader";

const QRScan = (props) => {
  const [scanned, setScanned] = useState(false);
  const debounceRef = useRef(null);

  const handleScan = (result) => {
    if (!result || scanned) return;

    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      const text = result?.text;

      // ✅ validasi biar tidak ke-trigger setengah
      if (text && text.length > 10) {
        if (text.includes("_X")) {

          let uidPart = "";

          if (text.includes("UID%3A")) {
            uidPart = text.split("UID%3A")[1];
          } else if (text.includes("UID:")) {
            uidPart = text.split("UID:")[1];
          }

          if (!uidPart) return;

          setScanned(true);
          props.onSuccess(uidPart.split("_")[0]);
        }
      }
    }, 200);
  };

  return (
    <>
      {/* 🔥 overlay gelap */}
      <div className="fixed top-0 left-0 w-screen h-screen bg-[#000000b3]" />

      {/* 🔥 header */}
      <div className="fixed py-20 z-50 top-0 left-0 w-screen h-screen flex flex-col justify-between items-center pointer-events-none">
        <div className="flex flex-col space-y-2 pointer-events-auto">
          <div className="text-white text-center font-bold text-2xl uppercase">
            {props.gate} {props.event}
          </div>
          <div className="text-white text-center font-semibold">
            Please scan QR Code
          </div>
        </div>

        <div className="w-full flex justify-center items-center pointer-events-auto">
          <button
            onClick={() => props.onClose()}
            className="min-w-[160px] px-10 py-2 bg-red-500 rounded-lg text-white font-bold"
          >
            CLOSE
          </button>
        </div>
      </div>

      {/* 🔥 CAMERA */}
      <div className="fixed top-1/2 -translate-y-1/2 left-0 w-screen h-[320px] overflow-hidden">
        <QrReader
          constraints={{
            facingMode: { ideal: "environment" }, // 🔥 paksa kamera belakang
            aspectRatio: 1,
            advanced: [
              { zoom: 2 } // 🔥 zoom (android biasanya jalan)
            ]
          }}
          scanDelay={200}
          videoStyle={{
            width: "100%",
            height: "100%",
            objectFit: "cover" // 🔥 penting biar tidak gepeng/cembung
          }}
          onResult={(result, error) => {
            if (result) {
              handleScan(result);

              // 🔥 paksa zoom manual (fallback)
              const track =
                document
                  .querySelector("video")
                  ?.srcObject?.getVideoTracks?.()[0];

              if (track?.applyConstraints) {
                track.applyConstraints({
                  advanced: [{ zoom: 2 }]
                });
              }
            }
          }}
        />

        {/* 🔥 FRAME SCAN */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="w-64 h-64 border-4 border-white rounded-xl" />
        </div>
      </div>
    </>
  );
};

export default QRScan;